module.exports = __webpack_public_path__ + "img/s3-3-ja.63fee7bf.jpg";